import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Finance reports" hint="P&L, Balance Sheet, Cash Flow, VAT, AR aging, Trial Balance." /> }
